import React from "react";
import PropTypes from "prop-types";

const SvgImage = ({ src, width, height, alt, className }) => {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{
        width,
        height,
        objectFit: "contain",
        display: "block",
      }}
    />
  );
};

SvgImage.propTypes = {
  src: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  alt: PropTypes.string,
  className: PropTypes.string,
};

SvgImage.defaultProps = {
  src: "",
  width: 200,
  height: 80,
  alt: "icon",
  className: "",
};

export default SvgImage;
